import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginRedirectGuard implements CanActivate {
  
  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean|UrlTree>|Promise<boolean|UrlTree>|boolean|UrlTree {
    
    // Check if user is already authenticated
    const accessToken = localStorage.getItem('access_token');
    
    if (accessToken) {
      // User is authenticated, redirect to dashboard
      this.router.navigate(['/dashboard']);
      return false;
    }
    
    // User is not authenticated, allow access to login page
    return true;
  }
}